
var article = `
## Paquetes:

- **Color Scheme**: One Dark Gravity - El paquete se llama Gravity

- **Select Theme**: Material Theme

## Configuraciones:

Para cambiar el tamaño de fuente de sidebar y pestañas voy a **Settings** y agrego: 

>**"ui_scale": 1.2**,

Para cambiar el tamaño de los íconos voy a:

1. **Preferences**.
2. **Package Settings**.
3. Busco el paquete de íconos y *abro su configuración*.

Ahí agrego: 

>**"size": 10**, por ejemplo. 
`

export default article;